<rotec-modal-v2
  [title]="modalRef.data.title | translate: { name: modalRef.data.name }"
  [darkMode]="true"
  [showCloseIcon]="!isClicked"
>
  <ng-container ngProjectAs="modal-main">
    @if (!isClicked) {
      <h3 translate>
        {{ modalRef.data.text }}
      </h3>
    } @else {
      <div class="loader">
        <div class="spinner-snake"></div>
      </div>
    }
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button dark rotec-button-secondary (click)="cancel()" [disabled]="isClicked">
      {{ 'COMMON_Cancel' | translate }}
    </button>
    <button dark rotec-button-warning (click)="confirm()" [disabled]="isClicked">
      {{ 'COMMON_Delete' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
